<template>
    <div class="club-step">
        <div class="club-step__main">
            <div class="club-step__confirmed">
                <p class="fancy-title">Wine Club</p>
                <p class="club-step__review-title">Your upcoming order</p>
                <div class="club-step__wine-selection__list">
                    <WineCard
                        v-for="item in wineList"
                        :key="`wine-${item.ID}`"
                        :id="item.ID"
                        :wine="item.Wine"
                        :quantity="item.Quantity"
                    />
                </div>
                <div class="club-step__review-summary">
                    <div class="club-step__review-summary-item">
                        <div class="club-step__review-summary-item-title">
                            Account status
                        </div>
                        <div class="club-step__review-summary-item-content">
                            <p class="club-step__membership-status">
                                {{ getMemberStatus }}
                            </p>
                        </div>
                    </div>
                    <div class="club-step__review-summary-item">
                        <div class="club-step__review-summary-item-title">
                            My Subscription
                        </div>
                        <div class="club-step__review-summary-item-content">
                            <div class="club-step__membership-unit">
                                <p class="club-step__membership-amount">
                                    {{ getMemberTier.AnnuallyBottles / 4 }}
                                </p>
                                <p class="club-step__membership-amount-text">
                                    Bottles/
                                    <br />quarter
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="club-step__review-summary-item">
                        <div class="club-step__review-summary-item-title">
                            My Wines
                        </div>
                        <div class="club-step__review-summary-item-content">
                            <p
                                class="club-step__wine-selection-title"
                                v-if="getActiveCatalog"
                            >
                                {{ getActiveCatalog.Title }}
                            </p>
                            <p class="club-step__wine-selection-title" v-else>
                                Custom Selection
                            </p>
                        </div>
                    </div>
                    <div class="club-step__review-summary-item">
                        <div class="club-step__review-summary-item-title">
                            Delivered to
                        </div>
                        <div class="club-step__review-summary-item-content">
                            <p v-if="getShippingAddress === null">
                                You have not set your shipping address.
                                <br />
                                Update your details and fill in your address.
                            </p>
                            <div
                                v-else
                                class="club-step__review-summary-item-address"
                            >
                                <p>
                                    {{ getShippingAddress.FirstName }}
                                    {{ getShippingAddress.Surname }}
                                </p>
                                <p>{{ getShippingAddress.Address }}</p>
                                <p>{{ getShippingAddress.City }}</p>
                                <p>
                                    {{ getShippingAddress.State }}
                                    {{ getShippingAddress.PostalCode }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <BillingMessage v-if="getSavedCardID === 0" />
                <Actions :actions="actions" />
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import WineCard from "./components/WineCard.vue";
import BillingMessage from "./components/BillingMessage.vue";
import Actions from "./components/Actions.vue";
export default {
    name: "Step5",
    components: {
        WineCard,
        BillingMessage,
        Actions,
    },
    mounted() {
        if (this.getActiveCatalog === undefined) {
            console.warn("No catlog set this component will not render");
        }
    },
    data() {
        return {
            actions: [
                {
                    title: "Change wine selection",
                    className: "btn-outline-primary",
                    method: this.changeSelection,
                },
                {
                    title: "Update account details",
                    className: "btn-outline-primary",
                    method: this.goToUpdateDetails,
                },
                {
                    title: "Update credit card",
                    className: "btn-outline-primary",
                    method: this.goToUpdateBilling,
                },
            ],
        };
    },
    computed: {
        ...mapGetters([
            "getSavedCardID",
            "getNextShipmentDate",
            "getShipmentWines",
            "getShippingAddress",
            "getActiveCatalog",
            "getMemberTier",
            "getMemberStatus",
            "getShippingAddressID",
        ]),
        wineList() {
            return this.getActiveCatalog
                ? this.getActiveCatalog.WineItems
                : this.groupedShipmentWines;
        },
        groupedShipmentWines() {
            const w = this.getUniqueWinesWithQuantity(this.getShipmentWines);
            return w;
        },
    },
    methods: {
        ...mapActions([
            "goToUpdateDetails",
            "goToUpdateBilling",
            "setConfigStep",
        ]),
        getUniqueWinesWithQuantity(arr) {
            return Object.values(
                arr.reduce((acc, obj) => {
                    const { ID } = obj;

                    if (ID) {
                        // If the object with the same ID is already in the accumulator, increase the quantity
                        if (acc[ID]) {
                            acc[ID].Quantity += 1;
                        } else {
                            // Otherwise, add the object to the accumulator with Quantity initialized to 1
                            acc[ID] = { ID, Quantity: 1, Wine: obj };
                        }
                    }

                    return acc;
                }, {}),
            );
        },
        changeSelection() {
            this.setConfigStep(0);
        },
    },
};
</script>
